// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__U9olc","modalForm":"UpgradeEpcsModal_modalForm__s0SKk","modalFooter":"UpgradeEpcsModal_modalFooter__2I3zL"};